import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useApplyRetentionOffer = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const t = useI18n();

  return useMutation(
    trpc.stripe.applyRetentionOffer.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.users.getUserPlan.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
        toast.success(t("cancellation.toast.offerSuccess"), {
          description: t("cancellation.toast.offerSuccessDescription"),
        });
      },
      onError: (error) => {
        console.error("Failed to apply retention offer", error);
        toast.error(t("cancellation.toast.offerError"), {
          description: t("cancellation.toast.offerErrorDescription"),
        });
      },
    }),
  );
};
